// extracted by mini-css-extract-plugin
export default {"drag-button":"update-form-item_drag-button__4wURR"};